import * as React from "react";
import { filterPatentNumber, sumComparisonGroup, transformTotals, filterBibs, getTopJournals, getTopMeshTerms } from "./CTSAReportHelper";
import "./PublicationsAndPatents.css";

interface Props {
    pubComparisonGroup?: string[];
    patentNumber?: {};
    patentSector?: {};
    awardTotal?: { KL2: number, K01: number, K08: number, K12: number, K23: number };
    bibs?: {}[];
    journals?: {}[];
    mesh?: {}[];
}
class PublicationAndPatent extends React.Component<Props, {}> {

    render() {

        const { patentNumber, patentSector, pubComparisonGroup, bibs, journals, awardTotal, mesh } = this.props;
        const { KL2PatentCount, KCOMPPatentCount, KL2ScholarPercentage, KCOMPScholarPercentage, KL2TopSector, KCOMPTopSector } = filterPatentNumber(patentNumber, patentSector, pubComparisonGroup, awardTotal);
        const { KL2AvgPub, KL2AvgAuthorPerPub, KL2FirstPerc, KL2LastPerc, KCOMPAvgPub, KCOMAvgAuthorPerPub, KCOMPFirstPerc, KCOMPLastPerc } = filterBibs(bibs, pubComparisonGroup, awardTotal);
        const { KL2TopJournals, KCOMPTopJournals } = getTopJournals(journals, pubComparisonGroup);
        const { KL2Mesh, KCOMPMesh } = getTopMeshTerms(mesh);
        return (
            <div>
                <div className="publication-grid-container">
                    <div className="bib-row-headers row-headers">
                        <span></span>
                        <span>Avg Number of Publications</span>
                        <span>Avg Number of Co-Authors per Publication</span>
                        <span>Author Position (first)</span>
                        <span>Author Position (last)</span>
                    </div>
                    <div className="journal-row-headers row-headers">
                        <span>Top 5 Journals</span>
                        <span>MeSH Terms</span>
                    </div>
                    {/*<div className="patent-row-headers row-headers">
                        <span>Total Patent Count</span>
                        <span>% of Scholars with Patent</span>
                        <span>Most Common Sector</span>
                    </div>*/}
                    <div className="kl2-bib-rows bib-rows">
                        <h5>KL2 Scholars (n={awardTotal.KL2})</h5>

                        <span>{KL2AvgPub}</span>
                        <span>{KL2AvgAuthorPerPub}</span>
                        <span>{KL2FirstPerc}</span>
                        <span>{KL2LastPerc}</span>

                    </div>
                    <div className="kl2-journal-rows journal-rows">
                        {
                            KL2TopJournals && <ul>
                                {KL2TopJournals.map((journal, i) => <li key={i} className="journal-title">{journal}</li>)}
                            </ul>
                        }
                        {
                            KL2Mesh &&
                            <ul>
                                {
                                    KL2Mesh.map((term, i) => <li key={i}>{term}</li>)
                                }
                            </ul>
                        }
                    </div>
                    {/*<div className="kl2-patent-rows patent-rows">
                        <span>{KL2PatentCount}</span>
                        <span>{KL2ScholarPercentage}</span>
                        <span>{KL2TopSector}</span>
                    </div>*/}
                    <div className="kcomp-bib-rows bib-rows">
                        <h5>K Comparison Scholars (n={sumComparisonGroup(awardTotal, pubComparisonGroup)})</h5>
                        <span>{KCOMPAvgPub}</span>
                        <span>{KCOMAvgAuthorPerPub}</span>
                        <span>{KCOMPFirstPerc}</span>
                        <span>{KCOMPLastPerc}</span>
                    </div>
                    <div className="kcomp-journal-rows journal-rows">
                        {
                            KCOMPTopJournals && <ul>
                                {KCOMPTopJournals.map((journal, i) => <li key={i} className="journal-title">{journal}</li>)}
                            </ul>
                        }
                        {
                            KCOMPMesh &&
                            <ul>
                                {
                                    KCOMPMesh.map((term, i) => <li key={i}>{term}</li>)
                                }
                            </ul>
                        }
                    </div>
                    {/*<div className="kcomp-patent-rows patent-rows">
                        <span>{KCOMPPatentCount}</span>
                        <span>{KCOMPScholarPercentage}</span>
                        <span>{KCOMPTopSector}</span>

                    </div>*/}
                    <div className="bib-row-title row-title-container">
                        <h5 className="row-title">Biblometrics</h5>
                    </div>
                    <div className="journal-row-title row-title-container">
                        <h5 className="row-title">Journals</h5>
                    </div>
                    {/*<div className="patent-row-title row-title-container">

                        <h5 className="row-title">Patents</h5>

                    </div>*/}
                </div>
            </div>
        )

    }
}

export default PublicationAndPatent;